import { render, staticRenderFns } from "./BaseButtonBack.vue?vue&type=template&id=18ebc576&scoped=true"
import script from "./BaseButtonBack.vue?vue&type=script&lang=js"
export * from "./BaseButtonBack.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonBack.vue?vue&type=style&index=0&id=18ebc576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebc576",
  null
  
)

export default component.exports